import React from 'react';
import EditScheduledMessagePage from '../ScheduledMessages/components/EditScheduledMessagePage';

function AdminScheduledMessageEdit() {
  return <EditScheduledMessagePage mode="admin" />;
}

export default AdminScheduledMessageEdit;
